import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import './styles/globals.css';
import { AppProviders } from './app/providers';
import { router } from './app/router';
import { ErrorBoundary } from './components/layout/ErrorBoundary';

// Recover from stale lazy-route chunks after a deploy. When a new build ships,
// the old hashed assets this tab references are removed from the server, so the
// next `lazy(() => import(...))` 404s with "Failed to fetch dynamically imported
// module". Vite fires `vite:preloadError` for exactly this — reload once to pull
// the fresh index.html + chunk map. A time-boxed guard prevents an infinite
// reload loop if the asset is genuinely unreachable (then the error is allowed
// to surface to the ErrorBoundary instead).
window.addEventListener('vite:preloadError', (event) => {
  const KEY = 'admin:preload-reload-at';
  const last = Number(sessionStorage.getItem(KEY) ?? 0);
  if (Date.now() - last < 10_000) return; // already tried recently — let it throw
  event.preventDefault(); // suppress the throw; the reload supersedes it
  sessionStorage.setItem(KEY, String(Date.now()));
  window.location.reload();
});

const root = document.getElementById('root');
if (!root) throw new Error('Root element not found');
createRoot(root).render(
  <ErrorBoundary>
    <AppProviders>
      <RouterProvider router={router} />
    </AppProviders>
  </ErrorBoundary>,
);
